import { useCallback } from "react";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const useTableEventHandlers = ({
  updateTableLayout,
  paginationQueryParameter,
  setQuery,
  appSection,
  resetTableLayout
}) => {
  const sendTelemetry = useSendTelemetry();
  const onPageSizeChange = useCallback(
    (newPageSize) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.PAGE_SIZE_CHANGED, {
        app_section: appSection,
        app_action_value: "page-size-select",
        page_size: newPageSize
      });
      paginationQueryParameter.setPagination({ page: 1, pageSize: newPageSize });
      updateTableLayout({ perPage: newPageSize });
    },
    [appSection, paginationQueryParameter, sendTelemetry, updateTableLayout]
  );
  const onSearch = useCallback(
    (newQuery) => {
      paginationQueryParameter.resetPage();
      setQuery(newQuery);
    },
    [paginationQueryParameter, setQuery]
  );
  const onLayoutPreferencesChange = useCallback(
    (layoutPreferences) => {
      if (layoutPreferences.order) {
        sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.COLUMN_ORDER_CHANGED, {
          app_section: appSection,
          app_action_value: "column-order-change",
          column_order: layoutPreferences.order
        });
      }
      if (layoutPreferences.attributes) {
        sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.COLUMNS_CHANGED, {
          app_section: appSection,
          app_action_value: "columns-select",
          columns: layoutPreferences.attributes
        });
      }
      const newLayoutPreferences = {};
      if ("order" in layoutPreferences) {
        newLayoutPreferences.order = layoutPreferences.order;
      }
      if ("attributes" in layoutPreferences) {
        newLayoutPreferences.attributes = layoutPreferences.attributes;
      }
      return updateTableLayout(newLayoutPreferences);
    },
    [appSection, sendTelemetry, updateTableLayout]
  );
  const onResetLayoutPreferences = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.COLUMNS_RESET, {
      app_section: appSection,
      app_action_value: "columns-select"
    });
    paginationQueryParameter.resetPage();
    return resetTableLayout();
  }, [appSection, paginationQueryParameter, resetTableLayout, sendTelemetry]);
  const onSearchReset = useCallback(() => {
    onSearch("");
  }, [onSearch]);
  const onSortChange = useCallback(
    (newSort) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SORT_CHANGED, {
        app_section: appSection,
        app_action_value: "sort-select",
        sort: newSort
      });
      paginationQueryParameter.resetPage();
      updateTableLayout({ sort: newSort });
    },
    [appSection, paginationQueryParameter, sendTelemetry, updateTableLayout]
  );
  return {
    onLayoutPreferencesChange,
    onPageSizeChange,
    onResetLayoutPreferences,
    onSearch,
    onSearchReset,
    onSortChange
  };
};
export default useTableEventHandlers;
